import { Route, Switch } from "react-router-dom";

import Layout from "@/containers/Layout";
import { ROUTES } from "@/routes_new";

import TagView from "./[slug]";
import EmptyTags from "./empty";

export type TagsViewProps = { className?: string };

const TagsView: React.FunctionComponent<TagsViewProps> = () => {
  return (
    <Layout>
      <Switch>
        <Route
          path={[ROUTES.TAG_ORGID, ROUTES.FAVORITES_ORGID]}
          component={TagView}
        />
        <Route path="*" component={EmptyTags} />
      </Switch>
    </Layout>
  );
};

export default TagsView;
